import React from 'react';

import '../../assets/css/App.css';
import MainContent from "../../components/mainContent/MainContent";
import TerminoUsers from './components/TerminoUsers';
  
export default function TerminoAdminUser() {

    return (
        <MainContent titulo='Administración Términos y Condiciones' component={ <TerminoUsers /> } />        
    );
  }